import { ChevronDown, CrossIcon } from "../../assets/icons";

/** Même hauteur que Button size SMI (h-9 = 36px), border incluse (border-box) */
const TRIGGER_BASE =
  "w-full h-9 box-border border rounded-md transition-colors border-gray-100 text-left ft-sm flex items-center";
/** État vide — aligné sur Button SECONDARY (hover / active) */
const TRIGGER_UNSELECTED =
  "bg-white text-gray-900 hover:bg-gray-100 active:bg-gray-200";
/** État avec sélection — fond marque (violet) */
const TRIGGER_SELECTED =
  "bg-workfully-600 text-white hover:bg-workfully-700 active:bg-workfully-800";

/**
 * Déclencheur des listes selectMultipleCheckbox / selectMultipleRadio (StyledInput).
 * Un seul composant pour le survol / press cohérents sur toute l’app.
 */
const SelectMultipleTrigger = ({
  hasSelection,
  value,
  onToggleOpen,
  variant = "checkbox",
  onClearAll,
}) => {
  const surface = `${TRIGGER_BASE} ${hasSelection ? TRIGGER_SELECTED : TRIGGER_UNSELECTED} px-1.5`;

  return (
    <div onClick={onToggleOpen} className={surface}>
      <div className="flex min-h-0 w-full min-w-0 flex-1 items-center justify-between gap-1">
        <div className="min-w-0 flex-1 truncate pr-1 leading-5">{value}</div>
        {!hasSelection && (
          <div className="flex shrink-0 items-center pl-1">
            <ChevronDown wh={20} color="#374151" />
          </div>
        )}
        {hasSelection && variant === "checkbox" && (
          <div
            className="flex shrink-0 items-center pl-0.5"
            onClick={(e) => {
              e.stopPropagation();
              onClearAll?.();
            }}
          >
            <CrossIcon wh={16} color="#FFFFFF" />
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectMultipleTrigger;
